<template>
  <div
    v-if="productRevealed"
    class="product-reveal"
  >
    <DiscountBanner
      v-if="!$_fsaHsaPromo_isActiveFsaHsaPromo"
      :show="Boolean(couponData.id)"
      :couponid="couponData.id"
    />
    
    <ReferralBanner />
    <div v-if="body.length > 0">
      <template v-if="isOnboardingRedesign">
        <template v-if="onboardingPatient?.non_hrt">
          <h2
            class="question-title tw-mb-0"
          >
            Great! You qualify for Winona’s non-HRT treatment options.
          </h2>
          <p
            class="sub-text tw-mb-6 tw-mt-4"
            :class="{
              'tw-text-[#787878]': isOnboardingRedesign && !['E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant),
              '!tw-text-black': isOnboardingRedesign && ['E1', 'F1', 'F2'].includes(onboardingVariant),
            }"
          >
            Choose your treatment(s) below.
          </p>
        </template>
        <template v-else>
          <DoctorHeader v-if="['E1','F3v1', 'F3v2', 'G', 'H', 'J'].includes(onboardingVariant)">
            Based on your symptoms and medical information, Winona recommends the following treatment.
          </DoctorHeader>
          <DoctorHeader v-else-if="['1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">
            Based on your symptoms and preference, Winona Physicians suggest...
          </DoctorHeader>
          <h2
            v-else
            class="question-title tw-mb-0"
          >
            Based on your symptoms and medical information, Winona recommends the following treatment.
          </h2>
          <p
            class="sub-text tw-mb-6 tw-mt-[2.4rem]"
            :class="{
              'tw-text-[#787878]': isOnboardingRedesign && !['E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant),
              '!tw-text-black': isOnboardingRedesign && ['E1', 'F1', 'F2', 'H', 'J', '1225-onboarding-core-v1', 'K'].includes(onboardingVariant),
            }"
          >
            <template v-if="['1225-onboarding-core-v1', 'K'].includes(onboardingVariant)">
              Review your treatments below. Don't worry — you can adjust them later and your doctor will review to ensure the selected treatment is right for you.
            </template>
            <template v-else>
              Choose your treatment(s) below. Don't worry — you can select multiple options and adjust them later. Your doctor will review to ensure the selected treatment is right for you.
            </template>
          </p>
        </template>
      </template>
      <template v-else>
        <h2 class="question-title">
          Based on your symptoms and preference, Winona Physician suggests...
        </h2>
        <p class="sub-text">
          Choose a plan. Don't worry - you can tweak this later, and your doctor
          will review if this treatment is right for you.
        </p>
      </template>
    </div>
    <div
      v-else
      class="mt-5"
    >
      <h2 class="question-title">
        Based on your medical questionnaire, we currently cannot suggest any
        treatment.
      </h2>
      <p class="sub-text">
        We recommend checking out some of our non prescription wellness
        products.
      </p>
    </div>

    <!-- Progesterone Modal -->
    <b-modal
      v-model="progesteroneModal"
      hide-header
      hide-footer
      centered
      :content-class="{'dark-bg': !isOnboardingRedesign}"
      no-close-on-backdrop
      backdrop.preventDefault
      no-close-on-esc
    >
      <div v-if="isOnboardingRedesign">
        <div class="tw-px-10 lg:tw-px-20 tw-mb-6">
          <h2 class="tw-text-2xl tw-mb-2">
            Because of your medical history, it would not be safe to take Estrogen
            without Progesterone.
          </h2>
        </div>
        <div
          class="tw-bg-white -tw-mx-6 -tw-mb-6 tw-px-6 tw-py-6 tw-rounded-b-[0.5rem]"
          style="box-shadow: -8px -6px 23.3px 0px rgba(45, 43, 43, 0.05);"
        >
          <div class="tw-max-w-[400px] tw-mx-auto">
            <b-button
              class="slight-rounded"
              pill
              block
              variant="info"
              :disabled="buttonDisabled"
              @click="progesteroneModal = false"
            >
              Continue
            </b-button>
          </div>
        </div>
      </div>
      <template v-else>
        <b-row class="mb-6">
          <b-col cols="12">
            <div class="icon-logo dark"></div>
          </b-col>
        </b-row>
        <div class="modal-card">
          <p
            class="sub-text"
            style="color: inherit"
          >
            Because of your medical history, it would not be safe to take Estrogen
            without Progesterone.
          </p>
          <b-button
            variant="info"
            pill
            block
            class="slight-rounded"
            @click="progesteroneModal = false"
          >
            Continue
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-row class="mt-2">
      <b-col v-if="body.length > 0">
        <template v-if="onboardingPatient?.non_hrt">
          <ProductRevealCheckboxV2
            v-for="product in body.slice(0, 2)"
            ref="ProductRevealCheckbox"
            :key="product.id"
            :product="product"
            :existing-pricing="getPricingFromOnboarding(product.id)"
            @set-selection="updateSelection"
            @update-shipping="updateShipping"
          />
          <template v-if="body.slice(2).length > 0">
            <hr class="tw-border-[#E9E9E9]">
            <h2
              class="question-title tw-mb-0"
            >
              Complete your treatment plan with an add-on:
            </h2>
            <p
              class="sub-text tw-mb-6 tw-mt-4 tw-text-[#787878]"
            >
              Sildenafil Arousal Cream is only available with the purchase of Estriol + Tretinoin Skin Cream or Minoxidil Hair Serum.
            </p>
            <ProductRevealCheckboxV2
              v-for="product in body.slice(2)"
              ref="ProductRevealCheckbox"
              :key="product.id"
              :product="product"
              :existing-pricing="getPricingFromOnboarding(product.id)"
              :has-product-selected="hasProductSelected"
              @set-selection="updateSelection"
              @update-shipping="updateShipping"
            />
          </template>
        </template>
        <template v-else>
          <ProductRevealCheckbox
            v-for="product in body"
            ref="ProductRevealCheckbox"
            :key="product.id"
            :product="product"
            :existing-pricing="getPricingFromOnboarding(product.id)"
            @set-selection="updateSelection"
            @update-shipping="updateShipping"
          />
        </template>
      </b-col>
    </b-row>

    <template v-if="!onboardingPatient?.non_hrt">
      <template v-if="isOnboardingRedesign">
        <div class="text-center sm:tw-mb-0">
          I’d prefer to <a
            class="text-underline mx-auto tw-text-[#1A6A72]"
            href="javascript:;"
            @click="skipPreference"
          >skip this and discuss with the doctor.</a>
        </div>

        <img
          src="@/assets/images/cro/hsa-fsa-eligible-badge.svg"
          alt=""
          class="tw-h-[30px] tw-mx-auto tw-my-4"
        >
      </template>
      <template v-else>
        <div class="text-center sm:tw-mb-0">
          <a
            class="text-default text-underline d-inline-block mx-auto"
            href="javascript:;"
            @click="skipPreference"
          >Skip Preference, I'd like to discuss with the doctor</a>
        </div>
      </template>
    </template>

    <OnboardingCTAContainer>
      <div class="tw-flex tw-flex-col tw-gap-2 tw-w-full">
        <div class="tw-w-full">
          <b-button
            v-if="body.length > 0"
            class="slight-rounded"
            :class="{'tw-max-w-[300px] tw-mx-auto tw-text-base md:tw-text-lg': isOnboardingRedesign}"
            variant="info"
            pill
            block
            :disabled="isOnboardingRedesign ? !(desiredplan.length > 0) || buttonDisabled : buttonDisabled"
            @click="submitAnswer(true)"
          >
            {{ buttonText }}
          </b-button>

          <b-button
            v-else
            class="slight-rounded"
            :class="{'tw-max-w-[300px] tw-mx-auto': isOnboardingRedesign}"
            variant="info"
            pill
            block
            :disabled="isOnboardingRedesign && !(desiredplan.length > 0)"
            @click="$emit('exit')"
          >
            Continue
          </b-button>
        </div>
      </div>
    </OnboardingCTAContainer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// components
import OnboardingCTAContainer from '@/components/onboarding/OnboardingCTAContainer';
import ProductRevealCheckbox from '@/components/onboarding/treatments/ProductRevealCheckbox';
import ProductRevealCheckboxV2 from '@/components/onboarding/treatments/ProductRevealCheckboxV2';
import DiscountBanner from '@/components/partials/DiscountBanner';

// services
import { OnboardingService } from '@/services/onboarding.service';
import { ProductService } from '@/services/product.service';

import analyticsMixin from '@/mixins/analytics';
import { fsaHsaPromoMixin } from '@/mixins/fsaHsaPromo';
import DoctorHeader from '@/components/partials/DoctorHeader.vue';
import ReferralBanner from '@/components/partials/ReferralBanner.vue';

export default {
  components: {
    ReferralBanner,
    DoctorHeader,
    ProductRevealCheckbox,
    ProductRevealCheckboxV2,
    OnboardingCTAContainer,
    DiscountBanner,
  },
  mixins: [analyticsMixin, fsaHsaPromoMixin],
  props: {
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
    body: {
      type: Array,
      default: () => [],
    },
    productRevealed: {
      type: Boolean,
      default: false,
    },
    onboardingflow: {
      type: String,
      default: 'flowA',
    },
    analyticsId: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    state: {
      type: String,
      default: '',
    },
    phoneno: {
      type: String,
      default: '',
    },
    firstname: {
      type: String,
      default: '',
    },
    lastname: {
      type: String,
      default: '',
    },
    onboardingData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      progesteroneModal: false,
      desiredplan: [],
      couponData: {
        id: ''
      },
      discountedProduct: {
        name: '',
      },
      showError: false,
      hasProductSelected: null
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
    buttonText() {
      return this.buttonDisabled ? 'Submitting' : 'Continue';
    },
  },
  watch: {
    body: {
      immediate: true,
      handler(products) {
        if (products && products.length === 1) {
          this.$nextTick(() => {
            if (this.$refs.ProductRevealCheckbox && this.$refs.ProductRevealCheckbox[0]) {
              const checkbox = this.$refs.ProductRevealCheckbox[0];
              checkbox.setSelected(true);
            }
          });
        }
      }
    },
    async onboardingData(data) {
      if (data.couponid) {
        const coupondata = await OnboardingService.checkCoupon(data.couponid);
        this.couponData = coupondata.data;

        if (this.couponData.id) {
          this.$emit('coupon', this.couponData.id);
        }
      }

      await this.$_analytics_track(
        'Onboarding Screen Viewed',
        {
          customerId: this.analyticsId,
          screen: '4-A',
          onboardingflow: this.onboardingflow,
          firstname: this.firstname,
          lastname: this.lastname
        },
      );
    },
    async couponData(coupon) {
      if (coupon.applies_to) {
        const { data } = await ProductService.getProduct(
          coupon.applies_to.products[0]
        );
        this.discountedProduct = data;
      }
    },
  },
  methods: {
    getPricingFromOnboarding(productid) {
      if (this.onboardingData.hasOwnProperty('desiredplan')) {
        const desiredplanobj = this.onboardingData.desiredplan.find(
          o => o.productid == productid
        );
        if (desiredplanobj && desiredplanobj.pricingdetail && desiredplanobj.pricingdetail.pricingid) {
          return desiredplanobj.pricingdetail.pricingid;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    updateSelection(id, selected, pricing, productselect, productdeselect) {
      // Manual selection and deselection
      if (selected) {
        // Item is not yet in the array
        if (!this.desiredplan.some(obj => obj.productid == id)) {
          this.desiredplan.push({
            productid: id,
            pricingid: pricing,
          });
        } else {
          // Item is already in the array (Update pricing)
          this.desiredplan.forEach(o => {
            if (o.productid == id && o.pricingid != pricing) {
              o.pricingid = pricing;
            }
          });
        }
      } else {
        this.desiredplan = this.desiredplan.filter(
          obj => obj.productid != id
        );
      }
      for (const currentProduct of this.$refs.ProductRevealCheckbox) {
        if (productselect != undefined) {
          if (productselect.includes(currentProduct.product.id) && selected) {
            currentProduct.setSelected(true);
          }
        }

        if (productdeselect != undefined) {
          if (
            productdeselect.includes(currentProduct.product.id) &&
            !selected
          ) {
            if (currentProduct.selected) {
              this.progesteroneModal = true;
            }
            currentProduct.setSelected(false);
          }
        }
      }

      if (this.onboardingPatient?.non_hrt) {
        this.hasProductSelected = this.$refs.ProductRevealCheckbox
          .reduce((acc, current) => {
            if (current.selected) {
              acc.push({
                productid: current.product.id,
                pricingid: current.selectedpricing,
                productname: current.product.name,
              });
            }
            return acc;
          }, [])
          .some(o => ['Estriol Face Cream with Tretinoin', 'Minoxidil Hair Serum'].includes(o.productname));
        if (!this.hasProductSelected) {
          for (const currentProduct of this.$refs.ProductRevealCheckbox) {
            if (currentProduct.product.name == 'Sildenafil Arousal Cream') {
              currentProduct.setSelected(false);
            }
          }
        }
      }
    },
    updateShipping(
      id,
      pricing,
      productselect,
      productdeselect,
      availablepricing
    ) {
      /**
       * 1. Update shipping id to whatever is supplied
       * 2. Check productselect for any matching items
       * 3. If there is a match, make sure that the subscriptiontype is the same
       */

      this.desiredplan.forEach(o => {
        if (o.productid == id && o.pricingid != pricing) {
          o.pricingid = pricing;
        }
      });

      const currentSubscriptionType = availablepricing.find(o => {
        return o.pricingid == pricing;
      }).subscriptiontype;

      if (productselect != undefined || productdeselect != undefined) {
        for (const currentProduct of this.$refs.ProductRevealCheckbox) {
          // if match is found
          if (
            (productselect != undefined &&
              productselect.includes(currentProduct.product.id)) ||
            (productdeselect != undefined &&
              productdeselect.includes(currentProduct.product.id))
          ) {
            // If match is selected
            if (currentProduct.selected) {
              // Check selectedpricing
              const targetPricings = currentProduct.product.availablepricing;

              // Set target pricing to correct subscription type
              currentProduct.selectedpricing = targetPricings.find(o => {
                return o.subscriptiontype == currentSubscriptionType;
              }).pricingid;
            }
          }
        }
      }
    },
    submitAnswer(answer) {
      if (this.desiredplan.length === 0) {
        this.showError = true;
        window.scrollTo(0, 0);
        return;
      }

      const answers = [
        {
          questionid: 'agreedToMedication',
          answer: answer,
        },
        {
          questionid: 'selectedProduct',
          answer: this.desiredplan,
        },
      ];
      this.$emit('submitAnswer', answers);
    },
    async fbqTrack(data) {
      // FB Pixel Tracking
      try {
        fbq('init', '348219289912097', {
          em: this.email,
          fn: this.firstname,
          ln: this.lastname,
          ph: this.phoneno,
          external_id: this.userid,
          extern_id: this.userid,
        });
        // fbq("track", "PageView");
        const pageViewBody = { userid: this.userid };
        OnboardingService.onboardingEvent('PageView', pageViewBody);
        fbq(
          'trackCustom',
          'TreatmentOptionSkipped',
          {
            external_id: this.userid,
            extern_id: this.userid,
            treatment: this.selectedproduct,
            ...(await this.$store.dispatch('getFBQParams')),
          },
          {
            eventID: data.eventid,
          }
        );
      } catch (err) {
        console.log(err);
      }
    },
    async skipPreference() {
      const body = {
        agreedtomedication: false,
        letdoctorchoose: true,
        desiredplan: [],
      };
      const data = await OnboardingService.updatePatientOnboarding(3.2, body);

      await OnboardingService.updatePatientOnboarding(4, {
        desiredaddon: [],
      });

      // Analytics
      await this.$_analytics_track('Treatment Option Chosen',
        {
          customerId: this.analyticsId,
          onboardingflow: this.onboardingflow,
          phoneno: this.phoneno,
          state: this.state,
          email: this.email,
          messageID: data.data.eventid,
          firstname: this.firstname,
          lastname: this.lastname,
          currency: 'USD',
          value: null,
          category: this.onboardingPatient?.non_hrt ? 'add_on' : 'core_products',
          type: this.onboardingPatient?.non_hrt ? 'Non-HRT' : undefined,
        },
      );

      await this.$_analytics_track(
        'Treatment Option Skipped',
        {
          firstname: this.firstname,
          lastname: this.lastname,
          customerId: this.analyticsId,
          onboardingflow: this.onboardingflow,
          phoneno: this.phoneno,
          state: this.state,
          email: this.email,
          messageID: data.data.eventid,
          products: []
        },
      );

      if (data.data.eventid) {
        await this.fbqTrack(data.data);
      } else if (
        data.data.eventid &&
        process.env.VUE_APP_SERVER != 'production'
      ) {
        console.log('FB TRACKING TreatmentSkipped');
        console.log('FB TRACKING TreatmentSkipped: ' + data.data.eventid);
      }

      if (data) {
        if (this.onboardingflow == 'flowB' || this.onboardingData.has_completed_non_doc_verification) {
          this.$router.push('/checkout').catch(() => {});
        } else {
          this.$router.push('/identity-verification').catch(() => {});
        }
      }
    },
  },
};
</script>

<style>
.text-small {
  font-size: 0.8rem !important;
}
</style>
